import React from "react"

const Gap = ({ blok }) => {
	const gapClass = blok?.EasyClasses || "h-8 md:h-12"

	return <div className={gapClass} aria-hidden="true" />
}

export default Gap
